<template>
  <virtual-in-person-selector ref="field" :field="field" />
</template>

<script>
import VirtualInPersonSelector from './virtual-in-person-selector'

export default {
  components: { VirtualInPersonSelector },

  props: {
    field: {
      type: String,
      required: true
    }
  },

  methods: {
    scrollIntoView() {
      this.$refs.field.scrollIntoView()
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

::v-deep(.radio-label) {
  font-size: 20px;
  padding: 15px 20px;
}

::v-deep(.virtual-location-kind-selector) {
  margin-top: 30px;

  label {
    font-size: 20px;
  }

  .form-check {
    gap: 20px;
  }

  .form-check:not(:first-child) {
    margin-top: 30px;
  }

  .form-check-input {
    float: none;
  }

  .form-check-label {
    font-size: 20px;
  }

  input#location-query-field {
    margin-bottom: 0;
  }
}

::v-deep(.location-editor) {
  margin-top: 30px;

  label {
    font-size: 24px;
    font-weight: 700;
  }
}

::v-deep(.hide-address-field), ::v-deep(.unconfirmed-location-field) {
  label {
    font-size: 24px;

    @include breakpoints.screen-mobile-only {
      font-size: 16px;
    }
  }

  .form-check {
    margin-top: 30px;
  }

  .form-check-input {
    margin-top: 10px;
  }

  .form-check-label {
    font-size: 20px;
    margin-left: 15px;
  }
}
</style>
